
$(document).ready(function() {
$(".navbar-toggler").click(function(){

  $(".navbar-toggler").toggleClass("showtoggle");

});



$(".closed").click(function(){

  $(".navbar-collapse").removeClass("show");

});   


    $(".jobsbtn span").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


    $(".searh_bx a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });

 });
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".header_sec").addClass("fixed");

    } else {
        $(".header_sec").removeClass("fixed");
    }
    if (scroll >= 250) {
        $(".backTop").addClass("actv");

    } else {
        $(".backTop").removeClass("actv");
    } 
});



$(document).ready(function() {
$('.banner-slider').owlCarousel({
  items: 1,
  loop: true,
  autoplay: true,
  autoplayTimeout: 5000, // MUST be longer than animation
  smartSpeed: 1000,
  animateOut: 'fadeOut',
  animateIn: 'fadeIn',
  nav: false,
  dots: false,
});
});
$(document).ready(function() {
$('.logo-carousel').owlCarousel({
    loop: true,
    margin: 30,
    autoplay: true,
    //autoplayTimeout: 0, // continuous scroll
   //// autoplaySpeed: 3000,
    //smartSpeed: 3000,
  //  slideTransition: 'linear',
    autoplayHoverPause: false,
    dots: false,
    nav: false,
    responsive: {
        0: { items: 2 },
        576: { items: 3 },
        768: { items: 4 },
        992: { items: 5 },
        1200: { items: 5 }
    }
});
});

$(document).ready(function() {
$('.news-carousel').owlCarousel({
    loop: false,
    margin: 20,
    dots: false,
    nav: true,

    navText: [
        '<i class="fa-solid fa-arrow-left-long"></i>',
        '<i class="fa-solid fa-arrow-right-long"></i>'
    ],

    responsive: {
        0: { items: 1 },
        668: { items: 2 },
        768: { items: 2 },
        992: { items: 3 }
    }
});
});


$(document).ready(function() {
$('.job-carousel').owlCarousel({
    loop: false,
    margin: 20,
    dots: false,
    nav: true,

    navText: [
        '<i class="fa-solid fa-arrow-left-long"></i>',
        '<i class="fa-solid fa-arrow-right-long"></i>'
    ],

    responsive: {
        0: { items: 1 },
        668: { items: 2 },
        768: { items: 2 },
        992: { items: 3 }
    }
});
});

$(document).ready(function() {
$('.team-carousel').owlCarousel({
    loop: false,
    margin: 20,
    dots: false,
    nav: true,

    navText: [
        '<i class="fa-solid fa-arrow-left-long"></i>',
        '<i class="fa-solid fa-arrow-right-long"></i>'
    ],

    responsive: {
        0: { items: 1 },
        668: { items: 2 },
        768: { items: 3 },
        992: { items: 4 }
    }
});
});



$(document).ready(function() {
$('.team-carouselDbl').owlCarousel({
    loop: false,
    margin: 20,
    dots: false,
    nav: true,

    navText: [
        '<i class="fa-solid fa-arrow-left-long"></i>',
        '<i class="fa-solid fa-arrow-right-long"></i>'
    ],

    responsive: {
        0: { items: 1 },
        468: { items: 2 },
        768: { items: 2 },
        992: { items: 4 }
    }
});
});



$(document).ready(function() {
$('.team-carouselDbl2').owlCarousel({
    loop: false,
    margin: 20,
    dots: false,
    nav: true,

    navText: [
        '<i class="fa-solid fa-arrow-left-long"></i>',
        '<i class="fa-solid fa-arrow-right-long"></i>'
    ],

    responsive: {
        0: { items: 1 },
        668: { items: 1 },
        768: { items: 1 },
        992: { items: 2 }
    }
});
});


$(document).ready(function() {
$('.job-lists-carocel').owlCarousel({
    loop: false,
    margin: 20,
    dots: false,
    nav: true,

    navText: [
        '<i class="fa-solid fa-arrow-left-long"></i>',
        '<i class="fa-solid fa-arrow-right-long"></i>'
    ],

    responsive: {
        0: { items: 1 },
        668: { items: 2 },
        768: { items: 2 },
        992: { items: 3 }
    }
});
});






